import * as Yup from 'yup';

export const projectSubtypeFormSchema = Yup.object().shape({
    projectSubType: Yup.string().required('Project subtype is required'),
});
